export default __webpack_public_path__ + "static/media/330_store01-nl-web.31999dfb.png";